







































import { useRouter } from "@/@core/utils/utils";
import useAppData from "@/views/modules/messaging-inbox/sidebar-right/useAppData";
import { ref, watch } from "@vue/composition-api";

export default {
    setup() {
        const { route } = useRouter();
        const { appModalContent, appModalIsActive, activeApp, appData } = useAppData();
        watch(
            () => route.value.fullPath,
            () => {
                appModalIsActive.value = false;
            }
        );

        const modalContent = ref();

        return { appModalContent, appModalIsActive, activeApp, appData, modalContent };
    },
};
